

export const wait = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};



// WEBPACK FOOTER //
// ./src/js/app/utils/promises/wait.js